export default __webpack_public_path__ + "3B0Z1QG-error.svg";